import { Alert, AlertTitle, Box, Button, Typography } from '@mui/material'
import * as z from 'zod'

type ParsedError = {
  name: string
  details: string
}
export function parseError(error: unknown): ParsedError {
  if (error instanceof z.ZodError) {
    return {
      name: 'Validation error',
      details: JSON.stringify(error.issues, null, 2),
    }
  }

  return {
    name: 'Unknown error',
    details: `${error}`,
  }
}

type ErrorStateProps = {
  title?: string
  error: unknown
  onRetry?: () => void
}

const ErrorState = ({
  title = 'Something went wrong',
  error,
  onRetry,
}: ErrorStateProps) => {
  const { name, details } = parseError(error)

  return (
    <Box display="flex" justifyContent="center">
      <Alert
        severity="error"
        action={
          <Button color="inherit" size="small" onClick={() => onRetry?.()}>
            Retry
          </Button>
        }
      >
        <AlertTitle gutterBottom>{title}</AlertTitle>
        <Typography variant="body1" gutterBottom>
          {name}:
        </Typography>
        <Typography component="pre" variant="body2">
          {details}
        </Typography>
      </Alert>
    </Box>
  )
}

export default ErrorState
